import api from "./api.service";
import { tokenService } from "./token.service";

export interface CustomerDashboardData {
  ordersCount: number;
  ordersOriginCount: number;
  ordersInTransitCount: number;
  ordersDeliveredCount: number;
  ordersVoided: number;
}

export interface GetCustomerDashboardResponse {
  statusCode: number;
  message: string;
  data: CustomerDashboardData;
}

class CustomerDashboardService {
  async getDashboardData(): Promise<GetCustomerDashboardResponse> {
    const token = tokenService.getToken();
    try {
      const response = await api.get<GetCustomerDashboardResponse>(
        "/get-dashboard",
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching customer dashboard data:", error);
      throw error;
    }
  }
}

export const customerDashboardService = new CustomerDashboardService();
